var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachToCase2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.977,
    height: 15.366,
    viewBox: "0 0 17.977 15.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link_folder",
    "data-name": "link folder",
    transform: "translate(-3670.374 -15334.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11513",
    "data-name": "Path 11513",
    d: "M813.8,11710.226v4.447a1.475,1.475,0,0,1-1.474,1.475h-11.9a1.466,1.466,0,0,1-1.467-1.467v-11.557a1.143,1.143,0,0,1,1.142-1.143h5.182a1.156,1.156,0,0,1,1.156,1.155v.358a1.112,1.112,0,0,0,1.112,1.114",
    transform: "translate(2872.014 3632.936)",
    fill: "none",
    stroke: "#353e44",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-link",
    "data-name": "Icon feather-link",
    transform: "translate(3675.402 15331.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11514",
    "data-name": "Path 11514",
    d: "M15,8.149a2.338,2.338,0,0,0,3.526.253l1.4-1.4a2.338,2.338,0,1,0-3.306-3.306l-.8.8",
    transform: "translate(-8.264)",
    fill: "none",
    stroke: "#353e44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11515",
    "data-name": "Path 11515",
    d: "M8.606,14.43a2.338,2.338,0,0,0-3.526-.253l-1.4,1.4a2.338,2.338,0,1,0,3.306,3.306l.8-.8",
    transform: "translate(0 -7.216)",
    fill: "none",
    stroke: "#353e44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachToCase2);
export default __webpack_public_path__ + "static/media/attachToCase2.14b9570e9844465a57b1a3e23e9821ab.svg";
export { ForwardRef as ReactComponent };